<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      :selectionEnabled="false"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
    ></dx-grid>

    <v-dialog
      v-model="userView.dialog"
      max-width="30%"
      style="background-color: brown;"
    >
      <manageengine-user-view
        :style="{ padding: '0 !important' }"
        :key="userView.dialogKey"
        :initial-data="{ user: userView.user }"
        @closeUserDialog="userView.dialog = false"
        @saveChanges="saveChanges"
      />
    </v-dialog>
    <v-dialog v-model="confirmChangeDialog.dialog" max-width="450">
      <v-card class="pa-4">
        <v-card-title class="headline pl-0 pt-0 pb-2"
          >Confirm Change</v-card-title
        >
        <v-card-text>{{ confirmChangeDialog.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="resolveConfirmChange(false)"
            >Cancel</v-btn
          >
          <v-btn color="success" @click="resolveConfirmChange(true)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <UserTicketsDialog
      v-if="selectedUserForTicket"
      :initial-data="{ manageengineUser: selectedUserForTicket }"
      @closed="selectedUserForTicket = null"
      @clearSearch="clearSearch"
    />
  </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";
import ManageEngineUserAutocomplete from "./ManageEngineUserAutocomplete.vue";
import PortalUserAutocomplete from "./PortalUserAutocomplete.vue";
import ManageengineUserView from "./ManageengineUserView.vue";
import UserTicketsDialog from "./UserTicketsDialog.vue";
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  components: {
    ManageEngineUserAutocomplete,
    PortalUserAutocomplete,
    ManageengineUserView,
    UserTicketsDialog,
  },
  data: () => ({
    url: "",
    title: "ManageEngine Users",
    actions: [],

    processing: false,

    userView: {
      user: null,
      dialog: false,
      dialogKey: 0,
    },

    newMapUser: {
      manageEngineUserAutocomplete: false,
      portalUserAutocomplete: false,
      dialog: false,
      selectedPortalUser: "",
      selectedManageengineUser: "",
      portalUsers: [],
    },

    mapExtension: {
      manageEngineUserAutocomplete: false,
      dialog: false,
      selectedExtension: "",
      selectedManageengineUser: "",
      manageEngineUsers: [],
    },

    mapPhone: {
      manageEngineUserAutocomplete: false,
      dialog: false,
      selectedPhone: "",
      selectedManageengineUser: "",
      manageEngineUsers: [],
    },

    confirmChangeDialog: {
      dialog: false,
      message: "",
      resolve: null,
    },

    selectedUserForTicket: null,
    rules: {
      required: (value) => !!value || "Required.",
      extension: (v) => /^\d{5}$/.test(v) || "Enter a valid extension",
      phone: (v) =>
        /^\d{10}$/.test(v) ||
        "Enter a valid phone without dashes or parentheses",
    },
    columns: [
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "link-action-cell-template",
      },
      {
        label: "Email Id",
        field: "emailId",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped Portal Username",
        field: "portalUsername",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Site",
        field: "siteName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Department",
        field: "departmentName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Phone in ManageEngine",
        field: "phone",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped Phone",
        field: "phoneMapped",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Extension",
        field: "extension",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Room",
        field: "room",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),

  created() {
    const nameColumn = this.columns.find((c) => c.field === "name");
    if (nameColumn) {
      nameColumn.linkAction = (row) => {
        this.userView.user = { ...row };
        this.userView.dialog = true;
        this.userView.dialogKey += 1;
      };
    }

    this.actions.push({
      text: "Search",
      type: "input",
      align: "left",
      onChanged: this.onSearch,
      clearable: true,
    });

    this.actions.push({
      text: "Sync Users",
      action: this.syncUsers,
    });
    this.actions.push({
      text: "Edit Users on ManageEngine",
      action: this.openManageEngineUsers,
    });
  },

  methods: {
    async beforeSetupGrid() {
      this.url = `ManageEngineUsers`;
    },
    async syncUsers() {
      try {
        const response = await this.$http.post(
          "api/ManageengineUsers/SyncManageengineUsers"
        );
        this.$notify({
          group: "notification",
          text: "Users synced successfully",
          type: "success",
        });
        this.$refs.grid.reloadGrid();
      } catch (error) {
        this.$notify({
          group: "notification",
          text: "Error syncing users",
          type: "error",
        });
      }
    },

    truncateText(text, count = 25) {
      return truncate(text, count);
    },

    async onRowClicked(row) {
      this.selectedUserForTicket = row;
    },
    onSearch(v) {
      if (!v || v == null || v == "null") {
        this.$refs.grid.grid.filter(null);
      } else {
        v = v.toLowerCase().trim();
        const filter = [
          ["EmailId", "contains", v],
          "or",
          ["Mobile", "contains", v],
          "or",
          ["Phone", "contains", v],
          "or",
          ["Name", "contains", v],
          "or",
          ["SiteName", "contains", v],
          "or",
          ["DepartmentName", "contains", v],
          "or",
          ["PortalUsername", "contains", v],
          "or",
          ["PhoneMapped", "contains", v],
          "or",
          ["Extension", "contains", v],
          "or",
          ["Room", "contains", v],
        ];
        this.$refs.grid.grid.filter(filter);
      }
    },

    clearSearch() {
      if (this.$refs.grid && this.$refs.grid.toolbarItems) {
        const toolbarItem = this.$refs.grid.toolbarItems.find(
          (item) => item.text === "Search"
        );
        if (toolbarItem && toolbarItem.options) {
          toolbarItem.options.value = "";
        }
      }
      this.onSearch(null);
    },
    saveChanges() {
      this.$refs.grid.reloadGrid();
      this.userView.dialog = false;
    },
    async openManageEngineUsers() {
      window.open("https://utaw.sdpondemand.manageengine.com/app/itdesk/AdminDetails.cc?forwardTo=user", "_blank");
    },
  },
};
</script>
